<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head">C<span class="small">ONTENTS</span></p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><a href="#/Acknowledgements#Ack">Acknowledgments</a></td></tr>
<tr><td colspan="2"><span href="#/Introduction#Intro" title="Link target outside of Sample">Introduction</span></td></tr>
<tr><td><span href="#/Chapter01#C1" title="Link target outside of Sample">1.</span></td><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Schools: Where Progress Begins, Where the Future Is Made</span></td></tr>
<tr><td><span href="#/Chapter02#C2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">Commerce: An Entrepreneurial Spirit</span></td></tr>
<tr><td><span href="#/Chapter03#C3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Worship: Places to Enrich the Spirit</span></td></tr>
<tr><td><span href="#/Chapter04#C4" title="Link target outside of Sample">4.</span></td><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Community: A Desire to Serve</span></td></tr>
<tr><td><span href="#/Chapter05#C5" title="Link target outside of Sample">5</span></td><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Homes: Reflections of Purpose and Personality</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?665a8171